import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Loading from "../general/Loading";
import Swal from 'sweetalert2';

function AgendarPaciente() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [aseguradoras, setAseguradoras] = useState([]);

    /*const [nombre, setNombre] = useState('');
    const [codigo, setCodigo] = useState('');
    const [empresa, setEmpresa] = useState('');*/

    const [estadosCita, setEstadosCita] = useState([]);
    const [unidadesAtencion, setUnidadesAtencion] = useState([]);
    const [profesionales, setProfesionales] = useState([]);

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('1');
    const [numeroDocumento, setNumeroDocumento] = useState('');

    const [fechaCita, setFechaCita] = useState();
    const [horaCita, setHoraCita] = useState();
    const [duracionCita, setDuracionCita] = useState();
    const [estadoCita, setEstadoCita] = useState();
    const [idUsers, setIdUsers] = useState();
    const [idUsuarioAsigna, setIdUsuarioAsigna] = useState();
    const [unidadAtencion, setUnidadAtencion] = useState();
    const [motivoConsulta, setMotivoConsulta] = useState();


    let history = useHistory();

    let userdata = [];
    let clientData = [];
    let rolePermissions = [];


    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }


        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {

                    setClient(response.data);
                    console.log('Client: ' + client.client_id);
                    setLoggedIn(true);
                }
            })
            .catch(error => {

                console.log('err: ' + error);
            });



        axios.get('/estados-cita?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEstadosCita(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });


        axios.get('/unidades-atencion?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setUnidadesAtencion(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            client_id: client.client_id,
            primer_nombre: primerNombre,
            segundo_nombre: segundoNombre,
            primer_apellido: primerApellido,
            segundo_apellido: segundoApellido,
            email: email,
            celular: celular,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,

            fecha_cita: fechaCita,
            hora_cita: horaCita,
            duracion_cita: duracionCita,
            estado_cita: estadoCita,
            id_users: idUsers,
            id_usuario_asigna: idUsuarioAsigna,
            id_unidad_atencion: unidadAtencion,
            motivo_consulta: motivoConsulta
        };

        console.log(conf);

        axios.post('/cita', conf)
            .then(
                response => {
                    setLoading(false);
                    // Success Modal with WhatsApp Option
                    Swal.fire({
                        title: 'Cita Agendada',
                        text: '¿Deseas enviar la confirmación por WhatsApp?',
                        icon: 'success',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, enviar WhatsApp',
                        cancelButtonText: 'No, gracias'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Construct WhatsApp Message
                            let msg = `Hola ${primerNombre} ${primerApellido}, le confirmamos su cita para el ${fechaCita} a las ${horaCita}.`;
                            let url = `https://wa.me/57${celular}?text=${encodeURIComponent(msg)}`;
                            window.open(url, '_blank');
                        }
                        history.push('/pacientes');
                    });
                }
            )
            .catch(
                err => {
                    console.log(err.response.data)
                    //setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><a href="/home">Home</a></li>
                                        <li className="breadcrumb-item" key="bc2"><a href="/menu-pacientes">Pacientes</a></li>
                                        <li className="breadcrumb-item" key="bc3">Agendar Cita</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Agendar Cita</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-10">

                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <a className="d-block w-100" data-toggle="collapse" data-target="#infobasica" href="#">
                                                        Nueva cita
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="infobasica">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-6" style={{ paddingRight: '14px' }}>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patientSearch">Buscar paciente</label>
                                                                        <input type="text" name="patient-search" className="form-control" id="patientSearch" placeholder="Buscar paciente" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="primer-nombre">Primer Nombre</label>
                                                                        <input type="text" name="primer-nombre" className="form-control" id="primer-nombre" onChange={(e) => setPrimerNombre(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="segundo-nombre">Segundo Nombre</label>
                                                                        <input type="text" name="segundo-nombre" className="form-control" id="segundo-nombre" onChange={(e) => setSegundoNombre(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="primer-apellido">Primer Apellido</label>
                                                                        <input type="text" name="primer-apellido" className="form-control" id="primer-apellido" onChange={(e) => setPrimerApellido(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="segundo-apellido">Segundo Apellido</label>
                                                                        <input type="text" name="segundo-apellido" className="form-control" id="segundo-apellido" onChange={(e) => setSegundoApellido(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="email">Email</label>
                                                                        <input type="email" name="email" className="form-control" id="email" onChange={(e) => setEmail(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="celular">Celular</label>
                                                                        <input type="text" name="celular" className="form-control" id="celular" onChange={(e) => setCelular(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="documento">No. de documento</label>
                                                                        <input type="text" name="documento" className="form-control" id="documento" onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="tipo-documento">Tipo documento</label>
                                                                        <select name="tipo-documento" className="form-control" id="tipo-documento" onChange={(e) => setTipoDocumento(e.target.value)} >
                                                                            <option value="1">CC</option>
                                                                            <option value="2">TI</option>
                                                                            <option value="3">CE</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6" style={{ paddingLeft: '14px' }}>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentDate">Fecha</label>
                                                                        <input type="date" name="appointment-date" className="form-control" id="appointmentDate" onChange={(e) => setFechaCita(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentTime">Hora</label>
                                                                        <input type="time" name="appointment-time" className="form-control" id="appointmentTime" onChange={(e) => setHoraCita(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentDuration">Duración</label>
                                                                        <select name="appointment-duration" className="form-control" id="appointmentDuration" onChange={(e) => setDuracionCita(e.target.value)}>
                                                                            <option value="1">15 min</option>
                                                                            <option value="2">30 min</option>
                                                                            <option value="3">45 min</option>
                                                                            <option value="3">1 hora</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentState">Estado de la cita</label>
                                                                        <select name="appointment-state" className="form-control" id="appointmentState" onChange={(e) => setEstadoCita(e.target.value)}>
                                                                            <option>-</option>

                                                                            {
                                                                                estadosCita.map((estadoCita) =>
                                                                                    <option value={estadoCita.id}>{estadoCita.nombre}</option>
                                                                                )
                                                                            }

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentPerson">Profesional asignado</label>
                                                                        <input type="text" name="appointment-person" className="form-control" id="appointmentPerson" placeholder="Profesional" onChange={(e) => setIdUsers(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentUser">Usuario que asigna</label>
                                                                        <input type="text" name="appointment-user" className="form-control" id="appointmentUser" placeholder="Usuario que asigna" onChange={(e) => setIdUsuarioAsigna(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentUnit">Unidad de atención</label>
                                                                        <select name="appointment-unit" className="form-control" id="appointmentUnit" onChange={(e) => setUnidadAtencion(e.target.value)}>
                                                                            <option>-</option>

                                                                            {
                                                                                unidadesAtencion.map((unidadAtencion) =>
                                                                                    <option value={unidadAtencion.id}>{unidadAtencion.nombre_unidad}</option>
                                                                                )
                                                                            }

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="appointmentReason">Motivo de consulta</label>
                                                                        <input type="text" name="appointment-reason" className="form-control" id="appointmentReason" onChange={(e) => setMotivoConsulta(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                        <div className="row" style={{ marginTop: '30px' }}>
                                            <div className="col-md-6">
                                                <button type="submit" className="btn btn-primary">
                                                    Agendar cita&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}

                                                </button>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default AgendarPaciente;